declare let __webpack_public_path__: string

__webpack_public_path__ = `${window.location.protocol}//${window.location.host}/`;

console.log('__webpack_public_path__', __webpack_public_path__)
